export enum ServerStateKeysEnum {
  Books = 'books',
  DoctorFullProfile = 'doctorFullProfile',
  SearchSuggestion = 'searchSuggestion',
  Search = 'search',
  MenuExpertise = 'menuExpertise',
  BaseInfo = 'baseInfo',
  CurrentDateTime = 'currentDateTime',
  Symptoms = 'symptoms',
  Receipt = 'receipt',
  IsBookmark = 'isBookmark',
  SlugProfile = 'slugProfile',
  Feedbacks = 'feedbacks',
  ServerTime = 'serverTime',
  AvailabilityNotification = 'availabilityNotification',
  InquiryPayment = 'inquiryPayment',
  Reviews = 'reviews',
  AverageRates = 'averageRates',
  CountOfFeedbacks = 'countOfFeedbacks',
  SatisfactionPercent = 'satisfactionPercent',
  DoctorTags = 'doctorTags',
  Rate = 'rate',
  AvailabilityStatus = 'availabilityStatus',
  SamanDoctorAvailabilityStatus = 'samanDoctorAvailabilityStatus',
  SamanCenterBookingSettings = 'samanCenterBookingSettings',
  CenterInsurances = 'centerInsurances',
  DoctorCenterDescriptions = 'doctorCenterDescriptions',
  DoctorCenters = 'doctorCenters',
  DoctorCenterServices = 'doctorCenterServices',
  DoctorOnlineChannels = 'doctorOnlineChannels',
  Services = 'services',
  WalletBalance = 'walletBalance',
  OnlineChannels = 'onlineChannels',
  GetCancellationPolicyStatus = 'getCancellationPolicyStatus',
  PaymentMethods = 'paymentMethods',
  GhandonPreference = 'ghandonPreference',
  ChatLifecycleAutoCloseHours = 'chatLifecycleAutoCloseHours',
}
